import { useTranslation } from 'react-i18next';
import { useCurrentSite } from '@hotjar/site';
import { useModalTrackingCode } from '@hotjar/webapp/hooks/useModalTrackingCode';
import { Alert } from './Alert';
import { SiteUrl } from './SiteUrl';

export function WarningState({ trackingUIPosition }: { trackingUIPosition?: string }): JSX.Element {
  const { data: currentSite } = useCurrentSite();
  const url = currentSite?.url;
  const { t } = useTranslation();
  const { show: showTrackingCodeModal } = useModalTrackingCode();
  const lastData = currentSite?.lastData;

  const openTrackingCodeModal = () => {
    if (currentSite) {
      showTrackingCodeModal(currentSite, 1, trackingUIPosition || 'Tracking Status');
    }
  };

  return (
    <>
      {url ? <SiteUrl url={url} /> : null}
      <Alert
        kind="warning"
        onAction={openTrackingCodeModal}
        actionText={t('activation:dashboard.status-card.verify-installation')}
        direction="column"
      >
        {t('activation:dashboard.status-card.spaces-no-data-since', { lastData })}
      </Alert>
    </>
  );
}
